export default __webpack_public_path__ + "static/media/beta.3b3e38a7.svg";